<template>
  <div class="bid-row">
    <f7-link @click="callUserDetail" style="width: 100%;">
      <div class="bid-row-container">
        <div class="bid-worker-logo">
          <img style="width: 2.5rem; height: 2.5rem;"
            :src="imageUrl+'?attachmentId='+worker.headImage"
            v-if="worker.headImage"/>
          <img style="width: 2.5rem; height: 2.5rem;"
            src="@/assets/img/avatar.png"
            v-else/>
        </div>
        <div class="bid-worker-content">
          <div style="display: flex; align-items: start;">
            <div class="bid-title">
              {{ worker.name }}
            </div>
            <competitiveness :score="worker.score"></competitiveness>
          </div>
          <div class="bid-worker-area">
            <div class="worker-auth" v-if="worker.userStatus === '30'">
              <span>已认证</span>
            </div>
            <div class="workYears">{{ worker.workingYears }}</div>
            <div>年&nbsp; | &nbsp;</div>
            <div>{{ worker.areas.map(item => item.nameDesc).join('，') }}</div>
          </div>
          <div class="bid-worker-features" v-if="personType === 'workmate'">
            <div
              class="bid-worker-feature-text"
              v-for="item in worker.workTypeList"
              :key="item.type+item.name"
              v-if="item.nameDesc && item.nameDesc !== ''">
              {{ item.nameDesc }}
            </div>
          </div>
          <div class="bid-worker-features" v-if="personType === 'professional'">
            <div
              class="bid-worker-feature-text"
              v-for="item in worker.positionList"
              :key="item.type+item.name"
              v-if="item.nameDesc && item.nameDesc !== ''">
              {{ item.nameDesc }}
            </div>
          </div>
        </div>
      </div>
    </f7-link>
  </div>
</template>
<script>
import { toPersonalDetail } from '@/util/native';
import { imageView } from '@/api/common';
import Competitiveness from '@/components/Competitiveness';

export default {
  props: ['worker', 'personType'],
  components: {
    Competitiveness,
  },
  data() {
    return {
      imageUrl: imageView,
    };
  },
  methods: {
    callUserDetail() {
      toPersonalDetail(this.personType, this.worker.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .bid-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0rem;
  }

  .bid-row-container {
    display: flex;
    justify-content: flex-start;
  }

  .bid-worker-logo {
    width: 3rem;
    height: 3rem;
  }

  .bid-worker-content {
    flex: auto;
  }

  .bid-title {
    font-size: 1rem;
    padding: 0rem 0rem 0rem 0rem;
  }

  .bid-worker-score {
    display: flex;
    align-items: center;
    border: 0.05rem solid #5ED69C;
    border-radius: 0.2rem;
    font-size: 0.8rem;
    font-weight: bold;
    height: 1.2rem;
    line-height: 1.2rem;
    margin: 0.1rem 0rem 0.1rem 0.5rem;
    width: 4.3rem;
    min-width: 4.3rem;
  }

  .bid-worker-score-title {
    font-size: 0.6rem;
    background-color: #0DC16A;
    color: #ffffff;
    border-radius: 0.2rem;
    text-align: center;
    width: 2.3rem;
    min-width: 2.3rem;
  }

  .bid-worker-score-text {
    color: #0DC16A;
    font-size: 1rem;
    text-align: center;
    width: 2rem;
    min-width: 2rem;
  }

  .bid-worker-area {
    display: flex;
    justify-content: flex-start;
    padding: 0.5rem 0rem;
    color: $second-font-color;
  }

  .worker-auth {
    min-width: 2.5rem;
    margin-right: 0.3rem;
    padding: 0rem 0.2rem;
    height: 1rem;
    font-size: 0.8rem;
    border: 0.05rem solid $red-color;
    border-radius: 0.2rem;
    color: $red-color;
  }

  .workYears {
    color: $theme-color;
  }

  .bid-features {
    font-size: 0.85rem;
    padding: 0.1rem 0rem;
    display: flex;
    flex-wrap: wrap;
  }

  .bid-worker-feature-text {
    display: inline-block;
    margin: 0rem 0.5rem 0rem 0rem;
    background-color: $panel-bg-color;
    height: 1rem;
    line-height: 1rem;
    padding: 0rem 0.2rem;
    border-radius: 0.2rem;
    color: $second-font-color;
  }

</style>



// WEBPACK FOOTER //
// src/components/BidWorker.vue